/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierPurchaseOrdersRestService } from '@gh/supplier-shared-data';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared";
import * as i2 from "@gh/supplier-shared-data";
var SupplierPurchaseOrderListBusinessService = /** @class */ (function () {
    function SupplierPurchaseOrderListBusinessService(userContext, restService) {
        this.userContext = userContext;
        this.restService = restService;
    }
    SupplierPurchaseOrderListBusinessService.prototype.findAll = function (showRejected, officeId) {
        return this.restService.findAll(showRejected, officeId);
    };
    SupplierPurchaseOrderListBusinessService.prototype.accept = function (orderId, version) {
        return this.restService.acceptOrder(orderId, version);
    };
    SupplierPurchaseOrderListBusinessService.prototype.reject = function (orderId, version) {
        return this.restService.rejectOrder(orderId, version);
    };
    SupplierPurchaseOrderListBusinessService.ɵfac = function SupplierPurchaseOrderListBusinessService_Factory(t) { return new (t || SupplierPurchaseOrderListBusinessService)(i0.ɵɵinject(i1.SupplierUserContext), i0.ɵɵinject(i2.SupplierPurchaseOrdersRestService)); };
    SupplierPurchaseOrderListBusinessService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierPurchaseOrderListBusinessService, factory: SupplierPurchaseOrderListBusinessService.ɵfac });
    return SupplierPurchaseOrderListBusinessService;
}());
export { SupplierPurchaseOrderListBusinessService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierPurchaseOrderListBusinessService, [{
        type: Injectable
    }], function () { return [{ type: i1.SupplierUserContext }, { type: i2.SupplierPurchaseOrdersRestService }]; }, null); })();
